var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBikeRoad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 7,
    style: {
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-372,-534.36218)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    x: 372,
    y: 534.36218,
    style: {
      color: "#000000",
      fill: "#0000ce",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 387,536.86218 -5,-2.5 0,2 -7,0 0,1 7,0 0,2 z",
    style: {
      fill: "#0000ce",
      stroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeRoad);
export default __webpack_public_path__ + "static/media/bike-road.64c2bf826f99a04354622f433243d2f2.svg";
export { ForwardRef as ReactComponent };